// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"7e8067b7","186":"201c8b87","225":"8b69daac","315":"ba516ef0","344":"53ea45c6","372":"11b50c0d","377":"bb7828cb","434":"aba0cf62","443":"821a4182","678":"450d72a2","738":"82cebbdd","841":"6c7cd7d3","849":"e67d66e8","856":"ef852a7f"}[chunkId] + ".chunk.js";
};